module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sub-ibox-title "
  }, [_c('h3', {
    staticClass: "fx fx-y-center"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowBack),
      expression: "isShowBack"
    }],
    staticClass: "back"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClick),
      expression: "isClick"
    }],
    staticClass: "icon-back",
    on: {
      "click": _vm.handleCustomFun
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isClick),
      expression: "!isClick"
    }, {
      name: "back-link",
      rawName: "v-back-link"
    }],
    staticClass: "icon-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fx fx-x-between fx-fill fx-y-center"
  }, [_vm._t("title"), _vm._v(" "), _vm._t("operation")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3107826e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/SubIboxTitle.vue
// module id = 827
// module chunks = 0